import { urlWithBasePath } from '~/utils/url-helpers';

export interface ProductProps {
    id: string;
    serviceType: string;
    description: string;
}

// session timeout - to be setup to 20minus  - 5 minus
export const SESSION_TIMEOUT_DEFAULT = 20 * 60 * 1000;
export const SESSION_TIMEOUT_CLOSE = 5 * 60 * 1000;

// product selector
export const productSelector: ProductProps[] = [
    {
        id: 'dl',
        serviceType: 'DLRA',
        description: "driver's licence",
    },
    {
        id: 'opc',
        serviceType: 'OPRA',
        description: 'ontario photo card',
    },
    {
        id: 'lps',
        serviceType: 'VLRA',
        description: 'licence plate',
    },
    {
        id: 'hc',
        serviceType: 'HCRA',
        description: 'health card',
    },
];

export const fontsPath = urlWithBasePath(`/fonts`);
